import { render, staticRenderFns } from "./manage_membership.vue?vue&type=template&id=82ca7cf4"
import script from "./manage_membership.vue?vue&type=script&lang=ts"
export * from "./manage_membership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports